import { createContext } from "react";
import { PurchasingCalendarEditsContextType } from "./type";

export const PurchasingCalendarEditsContext =
  createContext<PurchasingCalendarEditsContextType>({
    deliveryDateEdits: {},
    editMode: false,
    loading: false,

    setDeliveryDateEdits: () => {},
    setEditMode: () => {},
    saveEditsAndTriggerRun: async () => {},
    discardChanges: () => {},
  });
